// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type AdDeliveryContextProperties = {
  creative_id?: number;
  order_id?: number;
  advertiser_id?: number;
  slot_size: string;
  line_item_id?: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/ad_delivery_context/jsonschema/3-0-0';
export const adDeliveryContextName = 'ad_delivery_context';
export class AdDeliveryContext extends BaseTrackingContext<AdDeliveryContextProperties> {
  constructor(properties: AdDeliveryContextProperties) {
    super(adDeliveryContextName, schema, properties);
  }
}
